(function(){
  const selectElment = document.querySelector("#eureka--bundle-select");
  const savingElement = document.querySelectorAll('[save-button]');
  const savingButtonCloneValues = []; savingElement.forEach(e=> savingButtonCloneValues.push(e.cloneNode(true).dataset.itemSize));
  const purchaseBox = document.querySelector('[purchase-items-box]');
  const addButtons = document.querySelectorAll('[add-button]');
  const addToCart = document.querySelector('[add-to-cart]');
  const fixedToggler = document.querySelector('[fixed-toggler]');
  const bundleFooter = document.querySelector('.is-fixed[bundle--footer]');
  if(!selectElment){
    return;
  }
  
  /*****TOGGLE BUNDLE FOOTER*****/
  if(fixedToggler){
    fixedToggler.addEventListener('click',function(){this.closest('[bundle--footer]')?.classList.toggle('active')});
  }
  /****ADD FOOTER HEIGHT FOR FIXED POSITION FUNCTIONALITY****/
  async function buildFooter(){
    const propert1 = new Promise(()=>{bundleFooter.style.setProperty('--fixed-height','100%')});
    const propert2 = new Promise(()=>{bundleFooter.style.setProperty('--fixed-height',bundleFooter.querySelector('[bundle--footer-main]').scrollHeight + 'px')});
    const propert3 = new Promise(()=>{bundleFooter.style.setProperty('--start-height','0px')});
    await propert1; await propert2; await propert3;
  }
  if(bundleFooter){
    buildFooter();
  }

  /******UPDATE COUNTER*****/
  function itemCounter(){
    const itemCounter = document.querySelectorAll('.active[purchase-item]');
    const element = document.querySelector('.bundle-counter');
    if(element){element.innerHTML = itemCounter.length};
  }
  /******BUNDLE COLLECTION CHANGE FUNCTIONALITY*****/
  function selectChange(element){
    document.querySelector('[eureka-bundle-content]:not(.hidden)')?.classList.add('hidden');
    document.querySelector('#'+element.value)?.classList.remove('hidden');
  }
  selectElment.addEventListener("change",function(){selectChange(this)});

  /*********SAVING ELEMENT FUNCTIONALITY*******/
  if(savingElement.length > 0){
    function savingFunction(element){
      purchaseBox.innerHTML = '';
      for(i = 0; i < element.dataset.itemSize; i++){
        purchaseBox.insertAdjacentHTML('afterbegin',`<div purchase-item class="eureka--bundle__item"></div>`);
      }
      document.querySelector('[save-button].active').classList.remove('active');
      element.classList.add('active');
      addCookieItems();
    }
    savingElement.forEach((e)=>{e.addEventListener("click",function(){savingFunction(this)})});
  }

  /****ADD BUTTON FUNCTIONALITY***/
  if(addButtons.length > 0){
    function addItemToBox(element){
      const itemBox = document.querySelector('[purchase-item]:not(.active)');
      const parent = element.closest('[product--item]');
      const elementBox = element.closest('.card-information__button');
      if(element.dataset.buttonType == 'add'){
        if(!itemBox){
          return;
        }
        fillEmptyBox(itemBox,parent,elementBox);
      }
      else if(element.dataset.buttonType == 'remove'){
        removeItem(parent.dataset.uniqueId);
      }
      updateQuantity(elementBox,parent);
      removeItemThroughCross();
      updateAddtoCart();
      itemCounter();
    }
    addButtons.forEach(e=>{e.addEventListener("click",function(){addItemToBox(this)})});
  }

  /*********ADD ITEM INTO EMPTY BOX*********/
  function fillEmptyBox(itemBox,parent,elementBox){
    const html = `
      <div class="eureka--bundle__item-wrapper typeset0 center">
        <div class="remove-icon" remove-item data-id="${parent.dataset.uniqueId}">
          <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.4502" cy="9.11065" r="6.07378" fill="#D9D9D9"/>
            <path d="M10.4502 18.2777C7.17609 18.2777 4.18665 16.5694 2.54958 13.7223C0.912506 10.9108 0.912506 7.45874 2.54958 4.61166C4.18665 1.80016 7.17609 0.0563223 10.4502 0.0563223C13.6888 0.0563223 16.6782 1.80016 18.3153 4.61166C19.9524 7.45874 19.9524 10.9108 18.3153 13.7223C16.6782 16.5694 13.6888 18.2777 10.4502 18.2777ZM7.56757 6.28432C7.21168 6.64021 7.21168 7.17404 7.56757 7.49433L9.24023 9.167L7.56757 10.8397C7.21168 11.1955 7.21168 11.7294 7.56757 12.0497C7.88787 12.4056 8.42169 12.4056 8.74199 12.0497L10.4147 10.377L12.0873 12.0497C12.4432 12.4056 12.977 12.4056 13.2973 12.0497C13.6532 11.7294 13.6532 11.1955 13.2973 10.8397L11.6247 9.167L13.2973 7.49433C13.6532 7.17404 13.6532 6.64021 13.2973 6.28432C12.977 5.96402 12.4432 5.96402 12.0873 6.28432L10.4147 7.95698L8.74199 6.28432C8.42169 5.96402 7.88787 5.96402 7.56757 6.28432Z" fill="black"/>
          </svg>
        </div>
        <div class="eureka--bundle__item-image-box">
          <img src="${parent.dataset.imageSrc}" alt="${parent.dataset.productTitle}" width="100" height="100" loading="eager">
        </div>
        <div class="eureka--bundle__item-title h5">${parent.dataset.productTitle}</div>
      </div>
    `;
    itemBox.innerHTML = html;
    itemBox.classList.add('active');
    itemBox.setAttribute('data-id',parent.dataset.uniqueId);
    itemBox.setAttribute('data-product-id',parent.dataset.productId);
    elementBox.classList.add('active');
  }

  /*****REMOVE ITEM BY CLICKING ON CROSS BUTTON****/
  function removeItemThroughCross(){
    const removeItems = document.querySelectorAll('[remove-item]');
    if(!(removeItems.length > 0)){
      return;
    }
    function removeItemBox(element){
      const parentBox = document.querySelector('[product--item][data-unique-id="'+element.dataset.id+'"]');
      const elementBox = parentBox.querySelector('.card-information__button');
      removeItem(element.dataset.id,true,element);
      updateQuantity(elementBox,parentBox);
      itemCounter();
    }
    removeItems.forEach(e=>{e.addEventListener('click',function(){removeItemBox(this)})});
  }
  
  /******UPDATING INPUT QUANTITY BASED ON ITEMS IN THE BOX****/
  function updateQuantity(elementBox,parent){
    const uniqueId = parent.dataset.uniqueId;
    let counter = 0;
    const itemBoxes = document.querySelectorAll('[purchase-item]');
    itemBoxes.forEach(e=>{if(e.dataset.id == uniqueId){counter +=1}});
    if(counter == 0){
      elementBox.querySelector('input[name="quantity"]').value = 0;
      elementBox.classList.remove('active');
    }else
    {
      elementBox.querySelector('input[name="quantity"]').value = counter;
    }
    SetCookieValue();
    buildFooter();
  }

  /******REMOVE ITEM FROM THE BOX****/
  function removeItem(dataId, specificElementTriggered = false, specificElement = ''){
    const element = specificElementTriggered ? specificElement.closest('[purchase-item]') : purchaseBox.querySelector('[purchase-item][data-id="'+dataId+'"]');
    if(!element){return;}
    element.classList.remove('active');
    element.removeAttribute('data-id');
    element.removeAttribute('data-product-id');
    element.innerHTML = '';
    updateAddtoCart();
  }

  /*****UPDATE ADD TO CART STATUS****/
  function updateAddtoCart(){
    document.querySelector('[purchase-item]:not(.active)') ? addToCart.setAttribute('disabled',true) : addToCart.removeAttribute('disabled');
  }

  /*******STORE SELECTED DATA INSIDE COOKIES******/
  const cookieStorage = {
    setCookie: function setCookie(key, value, time, path) {
        var expires = new Date();
        expires.setTime(expires.getTime() + time);
        var pathValue = '';
        if (typeof path !== 'undefined') {
            pathValue = 'path=' + path + ';';
        }
        document.cookie = key + '=' + value + ';' + pathValue + 'expires=' + expires.toUTCString();
    },
    getCookie: function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    },
    removeCookie: function removeCookie(key) {
        document.cookie = key + '=; Max-Age=0; path=/';
    }
  };

  function SetCookieValue(){
    const purchaseItems = document.querySelectorAll('[purchase-item].active');
    const itemCookie = [];
    if(purchaseItems.length > 0){
      purchaseItems.forEach(e=>{if(e.dataset.id){itemCookie.push(e.dataset.id)}});
    }
    const json_str = JSON.stringify(itemCookie);
    cookieStorage.setCookie('mycookie', json_str,2628000000,'/');
  }
  addEventListener('beforeunload', (event) => {SetCookieValue()});

  /*********ADD COOKIE PRODUCTS TO ITEM BOXES********/
  function addCookieItems(){
    let cookieItems = cookieStorage.getCookie('mycookie');
    if(cookieItems){
      cookieItems = JSON.parse(cookieItems);
      cookieItems.forEach(e=>{
        const itemBox = document.querySelector('[purchase-item]:not(.active)');
        const parent = document.querySelector('[product--item][data-unique-id="'+e+'"]');
        const elementBox = parent.querySelector('.card-information__button');
        if(itemBox){
          fillEmptyBox(itemBox,parent,elementBox);
        }
        updateQuantity(elementBox,parent);
      })
      removeItemThroughCross();
      updateAddtoCart();
      buildFooter();
      itemCounter();
    }
  }addCookieItems();


  /*****ADD TO CART FUNCTIONALITY*******/
  if(addToCart){
    function addProductToCart(element){
       const itemBoxes = document.querySelectorAll('[purchase-item]');
      if(savingButtonCloneValues.includes(itemBoxes.length.toString())){
        let miniCart = document.querySelector('mini-cart');
        let bundleNumber = 1;
        const cookieBundleNumber = cookieStorage.getCookie('bundleNumber');
        if(cookieBundleNumber){
          bundleNumber = parseInt(cookieBundleNumber);
        }
        const items = [];
        let bogus = false;
        itemBoxes.forEach(e=>{if(e.classList.contains('active') && e.hasAttribute('data-product-id') && e.innerHTML != ''){items.push({id:e.getAttribute('data-product-id'),quantity:1,properties:{bundle:bundleNumber}})}else{bogus = true;}});
        if(bogus){
          return;
        }
        element.setAttribute('disabled', true);
        element.classList.add('loading');
        const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
  
        const body = JSON.stringify({
          items: items,
          sections: sections,
          sections_url: window.location.pathname
        });
  
        fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
             document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
           }
           else {
            miniCart && miniCart.renderContents(parsedState);
            cookieStorage.setCookie('bundleNumber', bundleNumber + 1 ,2628000000,'/');
             document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          element.classList.remove('loading');
          element.removeAttribute('disabled');
        });
      }
    }
    addToCart.addEventListener('click',function(){addProductToCart(this)});
  }
})();